import { Grid } from "@mui/material";
import { UseEntityStore } from "../../common/entityStore";
import { propCustomEnumField } from "../../common/entityStoreForm";
import { UseListStore } from "../../common/listStore";
import { TmOrderDto, ProjectDto, getInitialOrderData, setMailOrder, setContOrder, getMailProduct, getContProducts } from "./common";
import { PageTitle } from "../../layout/PageTitle";
import { getResource } from "../../common/localization";

function getText(key: string, defaultMessage?: string) {
    return getResource("Ui." + key, defaultMessage) as string;
}

export function TmProjectSelect({ useStore, useProjectsStore, updateOrder, readOnly, ask }: {
    useStore: UseEntityStore<TmOrderDto>;
    useProjectsStore: UseListStore<ProjectDto>;
    updateOrder(): void;
    readOnly: boolean;
    ask: (title: string, message: string) => Promise<boolean>;
}) {
    return <Grid container>
        <Grid item xs={2}>
            <PageTitle title={getText("TmOrder")} />
        </Grid>
        <Grid item container xs={10} lg={8} spacing={2} mb={2}>
            {!readOnly && <Grid item xs={4}>{propCustomEnumField(useStore)("projectCodeAndName", getText("Project"), useProjectsStore, {
                getId: p => p.code + ";" + p.name,
                getName: p => p.name,
                onChange: async (_newProjectCodeAndName, oldProjectCodeAndName) => {
                    if (useStore.getState().clientData.tmOrderType != null) {
                        if (!await ask(getText("TmOrder.ChangeProject.Title"), getText("TmOrder.ChangeProject.Content"))) {
                            useStore.getState().setClientDataProp("projectCodeAndName", oldProjectCodeAndName);
                            return;
                        }
                    }
                    useStore.getState().setClientData({ ...useStore.getState().clientData, ...getInitialOrderData() });
                    useStore.getState().setClientDataProp("tmOrderType", undefined);
                    selectProductWhenPossible(useStore, useProjectsStore);
                    updateOrder();
                }
            })}</Grid>}
        </Grid>
    </Grid>;
}

export function selectProductWhenPossible(useStore: UseEntityStore<TmOrderDto>, useProjectsStore: UseListStore<ProjectDto>) {
    let projectCodeAndName = useStore.getState().clientData.projectCodeAndName;
    if (projectCodeAndName == null && useProjectsStore.getState().items.length === 1) {
        projectCodeAndName = useProjectsStore.getState().items[0].code + ";" + useProjectsStore.getState().items[0].name;
        useStore.getState().setClientDataProp("projectCodeAndName", projectCodeAndName);
    }
    if (projectCodeAndName != null) {
        const mailProduct = getMailProduct(projectCodeAndName, useProjectsStore);
        const contProducts = getContProducts(projectCodeAndName, useProjectsStore);
        if (useStore.getState().clientData.tmOrderType == null) {
            useStore.getState().setClientDataProp("moProjectId", mailProduct?.projectId);
            if (mailProduct != null && contProducts.length === 0) {
                setMailOrder(useStore, mailProduct);
            } else if (mailProduct == null && contProducts.length > 0) {
                setContOrder(useStore, contProducts);
            }
        }
    }
}
